module.exports = __webpack_public_path__ + "static/media/wheel-cross-grove.479e7881.png";